<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :bordered="false">
        <inner-out-modal v-if="showForm" ref="modalForm" :formMode="formMode" @ok="modalFormOk" @cancel="modalFormClose"></inner-out-modal>
        <template v-if="!showForm">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据编号" v-model="queryParam.number"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="商品信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="条码、名称、规格、型号" v-model="queryParam.materialParam"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker style="width:100%" v-model="queryParam.createTimeRange" format="YYYY-MM-DD"
                      :placeholder="['开始时间', '结束时间']" @change="onDateChange" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择单据状态" allow-clear v-model="queryParam.status">
                      <a-select-option value="0">未审核</a-select-option>
                      <a-select-option value="9" v-if="!checkFlag">审核中</a-select-option>
                      <a-select-option value="1">已审核</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="6" :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  </a-col>
                </span>
              </a-row>
            </a-form>
          </div>
          <div class="table-operator" style="margin-top: 5px">
            <a-button v-if="btnEnableList.indexOf(1)>-1" @click="myHandleAdd" type="primary" icon="plus">新增</a-button>
            <a-button v-if="btnEnableList.indexOf(1)>-1" icon="delete" @click="batchDel">删除</a-button>
            <a-button v-if="checkFlag && btnEnableList.indexOf(2)>-1" icon="check" @click="batchSetStatus(1)">审核</a-button>
            <a-button v-if="checkFlag && btnEnableList.indexOf(7)>-1" icon="stop" @click="batchSetStatus(0)">反审核</a-button>
            <a-button v-if="isShowExcel && btnEnableList.indexOf(3)>-1" icon="download" @click="handleExport">导出</a-button>
          </div>
          <div>
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="myHandleDetail(record, '资产出库', prefixNo)">查看</a>
                <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="myHandleEdit(record)">编辑</a>
                <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="myHandleCopyAdd(record)">复制</a>
                <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
                <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗?" @confirm="() => myHandleDelete(record)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <template slot="customRenderStatus" slot-scope="status">
                <a-tag v-if="status == '0'" color="red">未审核</a-tag>
                <a-tag v-if="status == '1'" color="green">已审核</a-tag>
                <a-tag v-if="status == '9'" color="orange">审核中</a-tag>
              </template>
            </a-table>
          </div>
        </template>
        <bill-excel-iframe ref="billExcelIframe" @ok="modalFormOk" @close="modalFormClose"></bill-excel-iframe>
        <bill-detail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></bill-detail>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
  import InnerOutModal from './InnerOutModal'
  import BillExcelIframe from '@/components/tools/BillExcelIframe'
  import BillDetail from '@/views/bill/dialog/BillDetail'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { BillListMixin } from '@/views/bill/mixins/BillListMixin'
  import { deleteAction } from '@/api/manage'

  export default {
    name: "InnerOutList",
    mixins: [JeecgListMixin, BillListMixin],
    components: { InnerOutModal, BillExcelIframe, BillDetail },
    data () {
      return {
        queryParam: {
          number: "",
          materialParam: "",
          type: "出库",
          subType: "资产出库",
          depotId: undefined,
          creator: undefined,
          status: undefined,
          remark: ""
        },
        prefixNo: 'NCKD',
        urlPath: '/plugin/apply/inner_out',
        showForm: false,
        formMode: 'add',
        labelCol: { span: 5 },
        wrapperCol: { span: 18, offset: 1 },
        defDataIndex: ['action', 'number', 'materialsList', 'operTimeStr', 'userName', 'materialCount', 'totalPrice', 'status'],
        defColumns: [
          { title: '操作', dataIndex: 'action', align: "center", width: 160, scopedSlots: { customRender: 'action' } },
          { title: '单据编号', dataIndex: 'number', width: 160 },
          { title: '商品信息', dataIndex: 'materialsList', width: 220, ellipsis: true },
          { title: '单据日期', dataIndex: 'operTimeStr', width: 145 },
          { title: '操作员', dataIndex: 'userName', width: 80, ellipsis: true },
          { title: '数量', dataIndex: 'materialCount', width: 60 },
          { title: '金额合计', dataIndex: 'totalPrice', width: 80 },
          { title: '备注', dataIndex: 'remark', width: 200 },
          { title: '状态', dataIndex: 'status', width: 80, align: "center", scopedSlots: { customRender: 'customRenderStatus' } }
        ],
        url: {
          list: "/depotHead/list",
          delete: "/depotHead/delete",
          deleteBatch: "/depotHead/deleteBatch",
          batchSetStatusUrl: "/depotHead/batchSetStatus"
        }
      }
    },
    created() {
      this.initSystemConfig()
      this.getDepotData()
      this.initUser()
    },
    methods: {
      myHandleAdd() {
        this.formMode = 'add'
        this.showForm = true
        this.$nextTick(() => {
          this.$refs.modalForm.action = 'add'
          this.$refs.modalForm.add()
        })
      },
      myHandleEdit(record) {
        this.formMode = 'edit'
        this.showForm = true
        this.$nextTick(() => {
          this.$refs.modalForm.edit(record)
        })
      },
      myHandleCopyAdd(record) {
        this.formMode = 'add'
        this.showForm = true
        this.$nextTick(() => {
          this.$refs.modalForm.action = 'copyAdd'
          this.$refs.modalForm.edit(record)
        })
      },
      modalFormOk() {
        this.showForm = false
        this.loadData()
      },
      modalFormClose() {
        this.showForm = false
      },
      searchQuery() {
        this.loadData(1)
      },
      searchReset() {
        this.queryParam = {
          type: this.queryParam.type,
          subType: this.queryParam.subType
        }
        this.loadData(1)
      },
      myHandleDelete(record) {
        let that = this
        if(record.status === '0') {
          deleteAction(that.url.delete, {id: record.id}).then((res) => {
            if(res.code === 200){
              that.loadData(1)
            } else {
              that.$message.warning(res.data.message);
            }
          })
        } else {
          this.$message.warning("抱歉，只有未审核的单据才能删除，请先进行反审核！")
        }
      },
      batchDel: function () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
          return
        }
        let that = this
        let ids = ""
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ","
        }
        deleteAction(that.url.deleteBatch, { ids: ids }).then((res) => {
          if (res.code === 200) {
            that.loadData(1)
          } else {
            that.$message.warning(res.data.message)
          }
        })
      }
    }
  }
</script>